import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  isLoading: false,
  wishlistItems: {}
};

var wishlistReducer = function wishlistReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.ADD:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.ADD_RECIEVE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }

    case Types.REMOVE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.REMOVE_RECIEVE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }

    case Types.RECEIVE_GET:
      {
        var results = action.results;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          wishlistItems: results
        });
      }

    default:
      {
        return state;
      }
  }
};

export default wishlistReducer;